import { useTheme } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

/**
 *
 * @see https://mui.com/material-ui/icons/#svgicon
 */
function ErrorIcon(props: SvgIconProps) {
  const theme = useTheme();

  return (
    <SvgIcon {...props} data-svg="ErrorIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill={theme.palette.error.main} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2427 7.75737C16.6332 8.1479 16.6332 8.78106 16.2427 9.17158L9.17158 16.2427C8.78106 16.6332 8.1479 16.6332 7.75737 16.2427C7.36685 15.8521 7.36685 15.219 7.75737 14.8284L14.8284 7.75737C15.219 7.36685 15.8521 7.36685 16.2427 7.75737Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2427 16.2427C15.8521 16.6332 15.219 16.6332 14.8284 16.2427L7.75737 9.17158C7.36685 8.78106 7.36685 8.1479 7.75737 7.75737C8.1479 7.36685 8.78106 7.36685 9.17158 7.75737L16.2427 14.8284C16.6332 15.219 16.6332 15.8521 16.2427 16.2427Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}
export default ErrorIcon;
